export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'y',
'_.loadingSpinnerText': 'Espere, por favor',
'pageTimerMax.text': 'Pasará automáticamente a la página siguiente una vez transcurrido el tiempo.',
'pageTimerMax.timeLeft': 'Tiempo que queda',
'pageTimerMin.text': 'No se puede avanzar antes de que el tiempo expire',
'pageTimerMin.timeLeft': 'Tiempo que queda',
'pageTimerMin.allowNext': 'Puede continuar',
'survey.registerForm.label.email': 'Correo electrónico',
'survey.registerForm.label.newsletter': 'Deseo recibir el boletín de noticias',
'survey.registerForm.label.regulations': 'Acepto la Política de privacidad y las condiciones del uso',
'survey.registerForm.button.register': 'Regístrese',
'survey.registerForm.registered': 'Gracias por registrarse. Hemos enviado un un enlace de activación a tu dirección de correo electrónico.',
'survey.registerForm.cardHeader': 'Regístrese y recibe puntos',
'survey.registerForm.cardBody': 'Por completar la encuesta has recibido',
'survey.registerForm.cardBody2': 'Añadimos punto despues de registrar tu cuenta en swpanel.es. Introduzca su dirección de correo electrónico y registre una cuenta en swpanel.pl',
'survey.notProperDevice': 'Desafortunadamente, no puedes completar esta encuesta en este dispositivo.',
'survey.properDevices': 'Se puede acceder a la encuesta desde los siguientes dispositivos:',
'survey.device-phone': 'teléfono móvil',
'survey.device-tablet': 'tableta',
'survey.device-desktop': 'ordenador / portátil',
'nextSurveys.header.seeAlso': 'Ver más otras encuestas',
'nextSurveys.button.fill': 'Completa',
'question.noContent': 'Falta el contenido de la pregunta',
'question.input.placeholder.typeYourAnswer': 'Ingresa su respuesta',

'question.conjoint.go': 'Haga clic en el botón "Siguiente"',
'question.matrix.carousel.go': 'Pulse el botón "Siguiente"',
'question.carousel.prevBtn': 'Declaración anterior',
'question.carousel.nextBtn': 'Declaración siguiente',

'question.open.email.inputPlaceholder': 'Introduzca su dirección de correo electrónico',
'question.open.email.emailVerify.sendCode': 'Enviar código de verificación',
'question.open.email.emailVerify.enderCode': 'Introduzca el código recibido',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Introduzca el código',
'question.open.email.emailVerify.confirm': 'Confirmar',
'question.open.email.emailVerify.codeIncorrect': 'El código introducido es incorrecto',
'question.open.email.emailVerify.codeCorrect': 'Dirección de correo electrónico verificada correctamente',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Sostene rellenar',
'footer.buttonPrev.text': 'Deshacer',
'footer.buttonClear.text': 'Borrar',
'footer.buttonNext.text': 'Siguiente',
'footer.buttonEnd.text': 'Finalizar',
'footer.buttonStart.text': 'Iniciar encuesta',
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',
};
